<template>
  <div class="login-page">

    <div class="login-card">

      <!-- Logo / Brand -->
      <div class="brand">
        <img v-if="brandDt.logo" :src="brandDt.logo" class="logo-img" />
        <span>{{ brandDt.app_name }}</span>
      </div>

      <!-- Header -->
      <div class="form-header">
        <h1 v-if="activeForm === 'login'">Welcome back</h1>
        <h1 v-if="activeForm === 'signup'">Create your account</h1>
        <h1 v-if="activeForm === 'forgot'">Forgot Password</h1>

        <p v-if="activeForm === 'login'">
          New here?
          <a href="#" @click.prevent="switchForm('signup')">Sign up for free</a>
        </p>

        <p v-if="activeForm === 'signup'">
          Already have an account?
          <a href="#" @click.prevent="switchForm('login')">Login</a>
        </p>

        <p v-if="activeForm === 'forgot'">
          Enter your registered email to reset password
        </p>
      </div>

      <!-- Google -->
      <button
        v-if="activeForm === 'login'"
        class="google-btn"
        @click="loginGoogleNow"
      >
        <i class="bx bxl-google"></i>
        Continue with Google
      </button>

      <!-- Divider -->
      <div v-if="activeForm === 'login'" class="divider">
        <span>OR CONTINUE WITH</span>
      </div>

      <!-- LOGIN -->
      <form v-if="activeForm === 'login'" @submit.prevent="loginUser">

        <label>Email address</label>
        <div class="input-group">
          <input type="email" v-model="email" placeholder="name@company.com" />
        </div>

        <label>Password</label>
        <div class="input-group">
          <input :type="showPassword ? 'text' : 'password'" v-model="password" />
          <i
            class="bx"
            :class="showPassword ? 'bx-hide' : 'bx-show'"
            @click="showPassword = !showPassword"
          ></i>
        </div>

        <div class="meta-row">
          <a href="#" @click.prevent="switchForm('forgot')">Forgot Password?</a>
        </div>

        <button class="btn-primary" :disabled="loading">
          <span v-if="!loading">Login</span>
          <span v-else class="loader"></span>
        </button>

      </form>

      <!-- SIGNUP -->
      <form v-if="activeForm === 'signup'" @submit.prevent="submitSignup">

        <!-- <div class="split">
          <div>
            <label>First Name</label>
            <div class="input-group">
              <input type="text" v-model="fname" />
            </div>
          </div>

          <div>
            <label>Last Name</label>
            <div class="input-group">
              <input type="text" v-model="lname" />
            </div>
          </div>
        </div> -->

        <label>First Name</label>
        <div class="input-group">
          <input type="text" v-model="fname" />
        </div>

        <label>Last Name</label>
        <div class="input-group">
          <input type="text" v-model="lname" />
        </div>

        <label>Email</label>
        <div class="input-group">
          <input type="email" v-model="signupEmail" />
        </div>

        <label>Password</label>
        <div class="input-group">
          <input type="password" v-model="signupPassword" />
        </div>

        <button class="btn-primary" :disabled="loading">
          <span v-if="!loading">Register</span>
          <span v-else class="loader"></span>
        </button>

      </form>

      <!-- FORGOT -->
      <form v-if="activeForm === 'forgot'" @submit.prevent="submitForgot">

        <label>Email address</label>
        <div class="input-group">
          <input type="email" v-model="forgotEmail" />
        </div>

        <button class="btn-primary" :disabled="loading">
          <span v-if="!loading">Send Reset Link</span>
          <span v-else class="loader"></span>
        </button>

        <div class="meta-row center">
          <a href="#" @click.prevent="switchForm('login')">Back to Login</a>
        </div>

      </form>

    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useToast } from "vue-toastification";
import { loginNow,getUserById, registerNow, forgotNow } from "@/apis/authapis";
import { getAdminSettings } from "@/apis/aupadminapis";
import { apiBaseUrl } from "@/apis/appconst";
import { useRoute } from "vue-router";
import { validateField } from "@/other/validator";

const route = useRoute();
const toast = useToast();

// State
const email = ref("");
const password = ref("");
const showPassword = ref(false);
const loading = ref(false);

// Signup + Forgot fields
const fname = ref("");
const lname = ref("");
const signupEmail = ref("");
const signupPassword = ref("");
const mobile = ref("");
const forgotEmail = ref("");
const brandDt = ref({
        logo:"",
        fav:"",
        app_name:"Julytoss",
        app_short_name:"images/logo.png",
      });

// Current visible form
const activeForm = ref("login"); // login | signup | forgot

// 🔹 Switch form logic
const switchForm = (type) => {
  activeForm.value = type;
  // Reset loader
  loading.value = false;
};

// 🔹 Login Function
const loginUser = async () => {
  if (!email.value || !password.value) {
    toast.warning("Please enter both email and password");
    return;
  }

  if(!validateField(email.value,"email",toast)){
    return;
  }
  if(!validateField(password.value,"password",toast)){
    return;
  }

  loading.value = true;
  const res = await loginNow(email.value, password.value);
  loading.value = false;

  if (res.status) {
    toast.success(res.success || "Login successful");
    sessionStorage.setItem("ldata", JSON.stringify(res.user_dt));
    window.location.href = "/";
  } else {
    toast.error(res.success || "Invalid credentials");
  }
};

const loginUser1 = async (uid,rtype) => {
 
  loading.value = true;
  const res = await getUserById(uid);
  loading.value = false;
  
  if (res!=null) {
    toast.success("Login successful");
    sessionStorage.setItem("ldata", JSON.stringify(res));
    window.location.href = "/"+rtype;
  } else {
    toast.error("Invalid credentials");
  }
};

// 🔹 Signup Function
const submitSignup = async () => {
  if (!fname.value || !lname.value || !signupEmail.value || !signupPassword.value) {
    toast.warning("All fields are required");
    return;
  }

   if(!validateField(signupEmail.value,"email",toast)){
    return;
  }
  if(!validateField(signupPassword.value,"password",toast)){
    return;
  }


  loading.value = true;
  const res = await registerNow(fname.value, lname.value, signupEmail.value, signupPassword.value, mobile.value);
  loading.value = false;

  if (res.status) {
    toast.success(res.success || "Account created successfully");
    activeForm.value = "login";
  } else {
    toast.error(res.success || "Email already exists");
  }
};

const loginGoogleNow = async () => {
  window.location.href = apiBaseUrl+"google_login";
};

// 🔹 Forgot Password Function
const submitForgot = async () => {
  if (!forgotEmail.value) {
    toast.warning("Please enter your registered email");
    return;
  }

  if(!validateField(forgotEmail.value,"email",toast)){
    return;
  }

  loading.value = true;
  const res = await forgotNow(forgotEmail.value);
  loading.value = false;

  if (res.status) {
    toast.success(res.success || "Reset link sent to your email");
    activeForm.value = "login";
  } else {
    toast.error(res.success || "User not found");
  }
};

// 🔹 Right-side animation content
const phrases = ["Automate Workflows", "Build Instantly", "Analyze Smarter", "Engage Customers"];
const activePhrase = ref(phrases[0]);
let index = 0;

const  loadAiPgSettings = async ()=> {
  try {

    const res = await getAdminSettings();

    if (res.status && res.settings) {
      const settings = res.settings;

      brandDt.value.app_name = settings.app_name;
      brandDt.value.logo = (settings.app_logo.length>0)?(apiBaseUrl+settings.app_logo):"";
      brandDt.value.fav = (settings.app_fav.length>0)?(apiBaseUrl+settings.app_fav):"";
    }

  } catch (err) {
    console.error("loadAiPgSettings error:", err);
  } finally {
     console.error("loadAiPgSettings error:");
  }
}

onMounted(() => {

  try{
      //  const type = this.$route.query.type;
      //  let msg = this.$route.query.msg;
      const type = route.query.type;
    var msg   = route.query.msg;

        if (msg) {
          msg = decodeURIComponent(msg);  // 🔥 DECODE FIX
        }

      if (type) {
        if(type === "error"){
          this.toast.error(msg);
        }
        else{
          this.toast.success(msg);
        }
      }
    }
    catch(e){
      console.log("sdfsad",e);
    }

    try{
      //  const user_id = this.$route.query.user_id;
      //  const rtype = this.$route.query.rtype;
      const user_id = route.query.user_id;
      const rtype   = route.query.rtype;

        if (user_id) {
          loginUser1(user_id,rtype);
        }

    }
    catch(e){
      console.log("sdfsad",e);
    }

  setInterval(() => {
    index = (index + 1) % phrases.length;
    activePhrase.value = phrases[index];
  }, 3000);
  loadAiPgSettings();
   const udata = route.query.udata;

  if (udata) {
    const ldata = atob(udata);
    if (ldata.length > 0) {
      sessionStorage.setItem("ldata", ldata);
      window.location.href = "/";
    }
  }
});

</script>

<style scoped>
.login-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f6fb;
  font-family: "Inter", sans-serif;
}

.login-card {
  width: 420px;
  background: #ffffff;
  border-radius: 14px;
  padding: 2.4rem;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.08);
  border: 1px solid #e6ebf2;
}

/* Brand */
.brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 1.8rem;
}

.logo-img {
  width: 38px;
  height: 38px;
  object-fit: contain;
}

.brand span {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--primary);
}

/* Header */
.form-header {
  text-align: center;
  margin-bottom: 1.6rem;
}

.form-header h1 {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 0.4rem;
  color: #0f172a;
}

.form-header p {
  font-size: 0.9rem;
  color: #64748b;
}

.form-header a {
  color: var(--primary);
  font-weight: 600;
  text-decoration: none;
}

/* Google */
.google-btn {
  width: 100%;
  border: 1px solid #dbe2ec;
  background: #ffffff;
  padding: 0.7rem;
  border-radius: 10px;
  font-weight: 600;
  margin-bottom: 1.4rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #0f172a;
}

.google-btn:hover {
  background: #1e293b;
  color: #ffffff;
}

/* Divider */
.divider {
  text-align: center;
  font-size: 0.7rem;
  letter-spacing: 1px;
  color: #94a3b8;
  margin-bottom: 1.4rem;
  position: relative;
}

.divider span {
  background: #ffffff;
  padding: 0 10px;
}

.divider::before {
  content: "";
  height: 1px;
  background: #dbe2ec;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  z-index: -1;
}

/* Inputs */
label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
  display: block;
  margin-bottom: 6px;
}

.input-group {
  border: 1px solid #dbe2ec;
  border-radius: 10px;
  padding: 0.65rem 0.75rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  background: #f8fafc;
}

.input-group input {
  border: none;
  outline: none;
  flex: 1;
  background: transparent;
  color: #0f172a;
}

/* Meta */
.meta-row {
  text-align: right;
  margin-bottom: 1rem;
}

.meta-row.center {
  text-align: center;
}

/* Button */
.btn-primary {
  width: 100%;
  background: linear-gradient(135deg, #111827, #111827);
  color: #ffffff;
  border: none;
  padding: 0.75rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(30, 58, 138, 0.25);
}

.btn-primary:hover {
  opacity: 0.95;
}

/* Split */
.split {
  display: flex;
  gap: 10px;
}

/* Loader */
.loader {
  border: 3px solid rgba(255, 255, 255, 0.35);
  border-top: 3px solid #ffffff;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* =========================
   GLOBAL POLISH
   ========================= */

.login-card {
  max-width: 420px;
  width: 100%;
  margin: auto;
  transition: all 0.25s ease;
}

.form-header {
  margin-bottom: 1.8rem;
}

.form-header h1 {
  line-height: 1.25;
}

.form-header p {
  margin-top: 0.3rem;
}

/* =========================
   BRAND / LOGO FIX
   ========================= */

.brand {
  margin-bottom: 2rem;
}

.logo-img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

/* =========================
   INPUT CONSISTENCY FIX
   ========================= */

.input-group {
  min-height: 44px;
  padding: 0 0.85rem;
  background: #f8fafc;
  border: 1px solid #dbe2ec;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.input-group:focus-within {
  border-color: var(--primary);
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(30, 58, 138, 0.12);
}

.input-group input {
  height: 44px;
  font-size: 0.95rem;
  color: #0f172a;
}

.input-group i {
  font-size: 1.1rem;
  color: #94a3b8;
  cursor: pointer;
}

/* Fix password eye icon jump */
.input-group .bx-show,
.input-group .bx-hide {
  margin-left: 6px;
}

/* =========================
   LABEL SPACING FIX
   ========================= */

label {
  margin-bottom: 6px;
  margin-top: 10px;
}

form label:first-child {
  margin-top: 0;
}

/* =========================
   BUTTON STABILITY FIX
   ========================= */

.btn-primary,
.google-btn {
  min-height: 44px;
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.btn-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-primary:hover {
  transform: translateY(-1px);
}

.btn-primary:active {
  transform: translateY(0);
}

/* =========================
   GOOGLE BUTTON POLISH
   ========================= */

.google-btn {
  background: #ffffff;
  border: 1px solid #dbe2ec;
  margin-bottom: 1.6rem;
}

.google-btn:hover {
  background: #1e293b;
  color: #ffffff;
}

.google-btn i {
  font-size: 1.2rem;
}

/* =========================
   DIVIDER VISUAL FIX
   ========================= */

.divider {
  margin: 1.2rem 0 1.4rem;
}

.divider span {
  font-weight: 600;
  font-size: 0.7rem;
  color: #94a3b8;
}

/* =========================
   META / LINKS FIX
   ========================= */

.meta-row a {
  font-size: 0.85rem;
  color: var(--primary);
  text-decoration: none;
}

.meta-row a:hover {
  opacity: 0.8;
}

/* =========================
   MOBILE FIXES
   ========================= */

@media (max-width: 768px) {

  .login-card {
    box-shadow: none;
    border: none;
  }

  .input-group {
    background: #ffffff;
  }
}

/* Prevent input zoom on iOS */
input {
  font-size: 16px;
}

.login-page {
  -webkit-font-smoothing: antialiased;
}
</style>
